import { type ComponentProps, type FC } from "react";
import { Heading } from "@root/shared/components/Heading";
import { UserDeclineReport } from "@clientFrontend/features/declineReport/components/UserDeclineReport";
import * as styles from "./styles.css";

type Props = ComponentProps<typeof UserDeclineReport>;

export const UserDeclineReportIndex: FC<Props> = ({
  userDeclineReportContent,
  isBiyo,
  homeUrl,
  jobEntryIndexUrl,
}) => {
  return (
    <article className={styles.article}>
      <Heading tag="h1" size="xLarge" bold className={styles.pageTitle}>
        選考辞退の詳細
      </Heading>
      <UserDeclineReport
        userDeclineReportContent={userDeclineReportContent}
        isBiyo={isBiyo}
        homeUrl={homeUrl}
        jobEntryIndexUrl={jobEntryIndexUrl}
      />
    </article>
  );
};
